const contract_model = {
    beneficiary: {
        address: {
            building: '',
            city: '',
            country: '',
            number: '',
            state: '',
            street: ''
        },
        banks: [],
        fiscal_code: '',
        id: '',
        name: '',
        registry_number: '',
        type: '',
    },
    beneficiary_org_id: null,
    contractor: {
        address: {
            building: '',
            city: '',
            country: '',
            number: '',
            state: '',
            street: ''
        },
        banks: [],
        fiscal_code: '',
        id: '',
        name: '',
        registry_number: '',
        type: '',
    },
    contractor_org_id: null,
    responsible: {
        id: '',
        avatar: '',
        email: '',
        name: ''
    },
    responsible_user_id: null,
    data: {},
    expires_at: '',
    id: '',
    number: '',
    signed_at: '',
    type: '',
    url: ''
};
const contract_model2 = {
    beneficiary: null,
    beneficiary_org_id: null,
    contractor: null,
    contractor_org_id: null,
    responsible: null,
    responsible_user_id: null,
    data: {},
    expires_at: '',
    number: '',
    signed_at: '',
    type: '',
    url: ''
};
const invoice_model = {
    number: '',
    issued_at: '',
    due_date: '',
    merchant_info: {
        name: '',
        fiscal_code: '',
        registry_number: '',
        address: {
            region: '',
            city: '',
            stret: '',
        },
        bank: {
            name: '',
            account: ''
        }
    },
    customer_info: {
        name: '',
        fiscal_code: '',
        registry_number: '',
        address: {
            region: '',
            city: '',
            stret: '',
        },
        bank: {
            name: '',
            account: ''
        }
    }
};
const hotel_model = {
    name: '',
    city: '',
    organization: {
        name: ''
    },
    contract: [],
    context: '',
    test: false,
    contact: {
        phone: '',
        email: ''
    }
};
const reservation_model = {
    agency: {
        commissioning: {
            agency: {
                commission_percentage: ''
            },
            hotel: ''
        },
        name: ''
    },
    cancellation_policy: {
        ro: '',
        en: ''
    },
    check_in: '',
    check_out: '',
    client_contact: {
        contact: {
            address: {
                building: '',
                city: '',
                country: '',
                number: '',
                state: '',
                street: ''
            },
            email: '',
            phone: ''
        },
        id: null,
        context: '',
        first_name: '',
        title: '',
        last_name: '',
        observations: '',
    },
    final_price: '',
    hotel_contact: {
        address: '',
        city: '',
        contact_email: '',
        country: '',
        email: '',
        name: '',
        region: '',
        phone: ''
    },
    id: '',
    invoice: {
        address: {
            building: '',
            city: '',
            country: '',
            number: '',
            postal_code: '',
            region: '',
            street: ''
        },
        currency: '',
        fiscal_code: '',
        organization_name: '',
        price: '',
        registry_number: ''
    },
    pax: {
        adults: null,
        infants: null,
        half_seats: null,
        full_seats: null
    },
    pricing: {
        total: null,
        currency: null,
        after_tax: null,
        before_tax: null,
        paid_amount: null,
        payable_amount: null,
        booking_currency: null,
        booking_total: null,
        booking_exchange_rate: null
    },
    is_agency: '',
    nights: '',
    room_types: [{
        cancellation_policy: null,
        check_in: null,
        check_out: null,
        pax: {},
        price: [{
            amount: 0,
            currency: null,
            date: null,
        }],
        rate_plan: {
            id: null,
            meal_type: '',
            name: ''
        },
        room_type: {
            id: null,
            name: '',
            type: ''
        },
        total_price: {
            amount: 0,
            currency: null
        }
        
    }],
    rooms: '',
    rooms_nights: '',
    status: '',
    timestamp: '',
    total_price: '',
    user_id: ''
};
export default {
    'contract_item': contract_model,
    'contract_item2': contract_model2,
    'invoice_item': invoice_model,
    'hotel_item': hotel_model,
    'reservation_item': reservation_model,
};
